module.exports = __webpack_public_path__ + "img/wood_boards.b89c198f.jpg";